export const defaultStyles = {
  borderColor: "#E4E7EB",
  borderTopWidth: "1px",
  borderStyle: "solid",
  sizing: {
    width: "100%",
    height: "0px",
    minWidth: "auto",
    minHeight: "auto",
    maxHeight: "auto",
    maxWidth: "auto",
  },
  padding: {
    paddingTop: "12",
    paddingBottom: "12",
    paddingLeft: "24",
    paddingRight: "24",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
